import {Link} from 'react-router-dom';
import styles from '@shared/components/SideMenu/SideMenu.module.scss';
import {useMemo, useState} from 'react';
// Assets
import {ReactComponent as Arrow} from '@assets/icons/arrow.svg';
import {UserRole} from '@shared/enums/UserRole';
import {checkMinPrivileges} from '@shared/helpers/checkMinPrivileges';
import classNames from 'classnames';
import {UserModel} from '@shared/models/userModels';

export interface SideMenuLink {
	text: string;
	link: string;
	role?: UserRole;
}

export interface GroupProps {
	disabled?: boolean;
	icon: React.ReactNode;
	title: string;
	forSuperAdmin?: boolean;
	links: SideMenuLink[];
	userData?: UserModel;
	defaultExpanded?: boolean;
}

const Group = (props: GroupProps) => {
	const {title, icon, forSuperAdmin, links, userData, defaultExpanded = false} = props;
	const [collapsed, setCollapsed] = useState<boolean>(defaultExpanded);

	const isCollapsable = useMemo(() => !!links?.length, [links]);

	if (forSuperAdmin && !userData?.roles.includes(UserRole.Super_Admin))
		return <></>;

	return (
		<div
			className={classNames(styles.group, {[styles.disabled]: props.disabled})}
			data-collapsed={collapsed}>
			<div
				className={styles.title}
				role="button"
				tabIndex={isCollapsable ? 0 : -1}
				aria-expanded={collapsed}
				onKeyDown={(event) => {
					if (isCollapsable && (event.key === 'Enter' || event.key === ' ')) {
						event.preventDefault();
						setCollapsed(!collapsed);
					}
				}}
				onClick={() => isCollapsable && setCollapsed(!collapsed)}>
				<div className={styles.groupIcon}>{icon}</div>
				<h3>{title}</h3>
				{isCollapsable && (
					<div className={styles.arrow}>
						<Arrow />
					</div>
				)}
			</div>
			<div className={styles.groupContent}>
				<ul className={styles.list}>
					{links.map(
						({link, text, role}, index) =>
							(!!!role || checkMinPrivileges(role, userData)) && (
								<li key={link + index}>
									<Link to={link}>{text}</Link>
								</li>
							),
					)}
				</ul>
			</div>
		</div>
	);
};

export default Group;
